var multimediamodal = {
    badge: "NEW",
    heading: "Multimedia Library",
    intro: "We've added a multimedia library to your dashboard featuring official Marival Resorts photos, videos, and brand assets. To start using it, please review and accept the terms and conditions below.",
    termsButton: "Read Terms and Conditions",
    acceptTextBefore: "I have read and accept the terms and conditions for the use of ",
    acceptLinkText: "Marival Resorts’ multimedia materials",
    acceptTextAfter: ".",
    continueButton: "Continue"
}
module.exports = multimediamodal
